module.exports = __webpack_public_path__ + "img/back.5ddd2767.png";